import { ECartType, EItemGroup, IEcommerceSpecial } from '@services/ecommerceService';
import { getPriceWithoutVat } from '@utils/math';

import { ICartSpecialInfo } from '../../model';

export const createEcommerceSpecial = (service: ICartSpecialInfo): IEcommerceSpecial => ({
  productCode: service.productCode ? service.productCode.toUpperCase() : '',
  productName: service.productName,
  brandName: service.brandName,
  vat: service.vat,
  price: getPriceWithoutVat(service.priceSumWithVat, service.vat),
  fullPrice: service.priceSumWithVat,
  quantity: service.count,
  group: EItemGroup.FREE_GIFT,
  cartType: ECartType.Cart,
});
